/* eslint-disable no-param-reassign */
/* globals localStorage Headers */
import simpleRestProvider from 'ra-data-simple-rest';
import { fetchUtils } from 'react-admin';
import isEqual from 'lodash/isEqual';
import { getBrain2Url, getProNameHeader, redirectUrl } from '../brainApi';

const apiUrl = getBrain2Url();

const httpClient = (url, options = {}) => {
  const token = localStorage.getItem('token');

  const { headers = new Headers() } = options;
  headers.set('Pro-Name', getProNameHeader());

  const user = {
    authenticated: true,
    token: `Bearer ${token}`,
  };

  const fullOptions = { ...options, user, headers };
  return fetchUtils.fetchJson(url, fullOptions);
};

const restProvider = simpleRestProvider(apiUrl, httpClient);

const determineResource = (resource) => {
  return resource === 'service-bay' ? 'service-vehicle' : resource;
};

const validateAddress = (data) => {
  const { address_line_1, city, postal_code, state } = data;
  return !!address_line_1 && !!city && !!postal_code && !!state;
}

redirectUrl();

export default {
  getList: (resource, params) => {
    resource = determineResource(resource);
    return restProvider.getList(resource, params);
  },
  getOne: (resource, params) => {
    resource = determineResource(resource);
    return restProvider.getOne(resource, params);
  },
  getMany: (resource, params) => {
    resource = determineResource(resource);
    return restProvider.getMany(resource, params);
  },
  getManyReference: (resource, params) => {
    resource = determineResource(resource);
    return restProvider.getManyReference(resource, params);
  },
  update: (resource, params) => {
    resource = determineResource(resource);
    const diff = params.data;
    Object.keys(params.previousData).forEach((key) => {
      if (key in diff && isEqual(diff[key], params.previousData[key])) {
        delete diff[key];
      }
    });
    return httpClient(`${apiUrl}/${resource}/${params.id}`, {
      method: 'PUT',
      body: JSON.stringify(diff),
    }).then(({ json }) => ({ data: json }));
  },
  updateMany: (resource, params) => {
    resource = determineResource(resource);
    return restProvider.updateMany(resource, params);
  },
  create: async (resource, params) => {
    resource = determineResource(resource);
    const res = await restProvider.create(resource, params);

    if (resource === 'customer' && validateAddress(params.data)) {
      restProvider.create('customer-address', {
        data: {
          ...params.data,
          customer_id: res.data.id,
        },
      });
    }

    return res;
  },
  delete: (resource, params) => {
    resource = determineResource(resource);
    return restProvider.delete(resource, params);
  },
  deleteMany: (resource, params) => {
    resource = determineResource(resource);
    return restProvider.deleteMany(resource, params);
  },
};
